import React from 'react';
import { Tooltip as MantineTooltip } from '@mantine/core';
import { TooltipIcon } from 'pageFramework/uiControls/icons';

interface TooltipProps {
	value?: React.ReactNode;
}

export const Tooltip: React.FC<React.PropsWithChildren<TooltipProps>> = (props) => {
	const { value, children } = props;

	return (
		<div className="tooltipContainer">
			<div className="tooltipContent">{children}</div>
			{value && (
				<MantineTooltip label={value}>
					<span className="tooltipIconWrapper">
						<TooltipIcon />
					</span>
				</MantineTooltip>
			)}
		</div>
	);
};
